import { CurrencyPipe } from '@angular/common';
import { Component, input, InputSignal, signal } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'app-order-slider',
  imports: [CurrencyPipe, MatProgressBar],
  templateUrl: './order-slider.component.html',
  styleUrl: './order-slider.component.scss'
})
export class OrderSliderComponent {
  hasMinOrder: InputSignal<boolean> = input.required();
  orderDeliveryFee: InputSignal<number> = input.required();
  minOrder: InputSignal<number> = input.required();
  minOrderDiffForFreeDelivery: InputSignal<number> = input.required();
  progressBarColor = signal('');
  percentMinSpend: InputSignal<number> = input.required();
  currentSliderInfo: InputSignal<any> = input.required();
  enableFreeDeliveryThreshold: InputSignal<boolean> = input.required();
  hasDeliveryFeeRange: InputSignal<boolean> = input.required();
}
